import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import Amplitude from 'react-amplitude';
import store from './store';
import App from './app';

import './styles/base.scss';

Amplitude.init('f3e44b6995c2aa11d11f32441332f5cc');

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App/>
    </Router>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js